import { SaveEnvironmentalDiscountAmountForm } from '@module/evaluation/model/SaveEnvironmentalDiscountAmountForm';
import { evaluationApi } from '../api';

export const environmentalApi = evaluationApi.injectEndpoints({
  endpoints: (build) => ({
    saveEnvironmentalDiscountAmount: build.mutation<
      void,
      { evaluationId: number; form: SaveEnvironmentalDiscountAmountForm }
    >({
      query: ({ evaluationId, form }) => ({
        url: `/${evaluationId}/environmental-discount-amount/save`,
        data: form,
        method: 'POST'
      })
    })
  }),
  overrideExisting: false
});

export const { useSaveEnvironmentalDiscountAmountMutation } = environmentalApi;
